import { Action } from '@ngrx/store';

export enum AutocompleteActionTypes {
  Load = '[Autocomplete] Load',
  LoadSuccess = '[Autocomplete] Load Success',
  LoadFail = '[Autocomplete] Load Fail',
  LoadSingle = '[Autocomplete] Load single ',
  LoadSingleSuccess = '[Autocomplete] Load single Success',
  LoadSingleFail = '[Autocomplete] Load single Fail',
  LoadCollections = '[Autocomplete] Load autocomplete collections',
  LoadCollectionsSuccess = '[Autocomplete] Load collections success',
  LoadTags = '[Autocomplete] Load autocomplete tags',
}

export class Load implements Action {
  readonly type = AutocompleteActionTypes.Load;
  constructor() {}
}

export class LoadCollections implements Action {
  readonly type = AutocompleteActionTypes.LoadCollections;
  constructor(public FollowId: number) {}
}

export class LoadTags implements Action {
  readonly type = AutocompleteActionTypes.LoadTags;
  constructor(public FollowId: number) {}
}

export class LoadSuccess implements Action {
  readonly type = AutocompleteActionTypes.LoadSuccess;
  constructor(public results: string[], public route: string) {}
}

export class LoadFail implements Action {
  readonly type = AutocompleteActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class LoadSingle implements Action {
  readonly type = AutocompleteActionTypes.LoadSingle;
  constructor(public route: string) {}
}

export class LoadSingleSuccess implements Action {
  readonly type = AutocompleteActionTypes.LoadSingleSuccess;
  constructor(public results: string[], public route: string) {}
}

export class LoadCollectionsSuccess implements Action {
  readonly type = AutocompleteActionTypes.LoadCollectionsSuccess;
  constructor() {}
}

export class LoadSingleFail implements Action {
  readonly type = AutocompleteActionTypes.LoadSingleFail;
  constructor(public error: any) {}
}

export type AutocompleteActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | LoadSingle
  | LoadSingleSuccess
  | LoadCollections
  | LoadCollectionsSuccess
  | LoadTags
  | LoadSingleFail;
